(function registerOwnerSettlementAccounts(scope) {
  // Retningsbestemt standardkonto for eier-/privatoppgjor pa en banklinje.
  //
  // ENK: uttak og innskudd er egenkapitalbevegelser, og de har hver sin konto.
  // AS/ASA: eierforholdet er mellomregning, og begge retninger foreslar samme
  // konto med vilje. Det er saldoen pa den ene kontoen som avgjor om et uttak er
  // tilbakebetaling av selskapets gjeld til eier eller et nytt lan til aksjonaer
  // (asl. §8-7, sktl. §10-11 fjerde ledd). Splittes retningene pa to kontoer,
  // kan samme person sta med bade fordring og gjeld, og den vurderingen blir
  // vanskeligere enn den trenger a vaere.
  //
  // Andre former far ingen default. Deltakerlignede selskap, samvirke, stiftelse
  // og NUF har egne eiertransaksjonsregler som ikke er implementert, og et
  // forslag herfra ville vaert en gjetning.
  const DIRECTIONAL_DEFAULTS = {
    sole_trader: { outbound: '2060', inbound: '2063' },
    limited_company: { outbound: '2250', inbound: '2250' },
  };

  const cleanCode = (value) => String(value || '').trim().match(/^([0-9]+)/)?.[1] || '';

  const resolveOwnerSettlementDefault = ({ entityFamily, amount, availableCodes = [] } = {}) => {
    const family = String(entityFamily || 'unknown');
    const direction = Number(amount) < 0 ? 'outbound' : Number(amount) > 0 ? 'inbound' : '';
    const empty = { code: '', direction, warningCode: '' };
    if (!direction) return { ...empty, reasonCode: 'amount_missing' };
    const profile = DIRECTIONAL_DEFAULTS[family];
    if (!profile) {
      return { ...empty, reasonCode: family === 'unknown' ? 'entity_family_unknown' : 'entity_family_not_implemented' };
    }
    const code = profile[direction];
    const codes = new Set((Array.isArray(availableCodes) ? availableCodes : []).map(cleanCode));
    if (!codes.has(code)) return { ...empty, reasonCode: 'account_not_in_chart' };
    // Uttak fra et AS er den ene retningen med en skattekonsekvens brukeren ma
    // ta stilling til. Kontoen foreslas, men vurderingen gjores ikke for dem.
    const warningCode = family === 'limited_company' && direction === 'outbound' ? 'shareholder_withdrawal' : '';
    return { code, direction, warningCode, reasonCode: 'directional_default' };
  };

  scope.PlummeOwnerSettlement = { resolveOwnerSettlementDefault };
})(typeof window !== 'undefined' ? window : globalThis);
